import React from 'react';
import EventCard from './component';

export default React.memo(EventCard);
